import React, { Component } from 'react';
import Table from 'react-bootstrap/lib/Table';
import GutschriftProductTableFilter from './GutschriftProductTableFilter';
import Time from 'react-time-format';
import { Link } from 'react-router-dom';
import Currency from '../../components/Currency';
import { Space, Tooltip } from 'antd'

class GutschriftProductTable extends Component {

	state = {
		showContract: true
	}

  	render() {

  		const { clients, products, getProducts, storageDownloadListUrl, brands } = this.props;

  		// let total = 0;
		let euro_total = 0;
		let cny_total = 0;
		let usd_total = 0;
		let delivered_total = 0;

  		let totalWeight = 0;

	    return (
	    	
		  	<Table striped bordered condensed hover>
			    <thead>
			      	<tr className="info">
			      		<th>#</th>
			      		<th>ID</th>
				        <th>{React.Component.prototype.$intl.get('订单')}</th>
				        <th>{React.Component.prototype.$intl.get('客户')}</th>
				        <th>{React.Component.prototype.$intl.get('型号')}</th>
				        <th>Gutschrift</th>
				        <th>收到账单</th>
				        <th>{React.Component.prototype.$intl.get('数量')}</th>
				        <th>{React.Component.prototype.$intl.get('到货数量')}</th>
				        <th>{React.Component.prototype.$intl.get('单价')}</th>
				        <th>到货总价</th>
				        <th>{React.Component.prototype.$intl.get('重量')}</th>
			      	</tr>
			    </thead>
			    	
			    <tbody>
			    	<GutschriftProductTableFilter brands={brands} clients={clients} getProducts={getProducts} storageDownloadListUrl={storageDownloadListUrl}/>
			      	{
		              	products.map((product, index) => {

							let delivered_quantity_cost = product.delivered_quantity;
							if (product.delivery_status && !product.delivered_quantity) {
								delivered_quantity_cost = product.amount;
							}

							let price = (product.contract_price > 0) ? product.contract_price : product.price;
							let currency = (product.contract_price > 0) ? <Currency currency={product.contract_currency}/> : <Currency currency={product.price_currency}/>;
							if (product.contract_price > 0 && product.contract_currency > 0) {
								if (product.contract_currency == 1) {
									cny_total += delivered_quantity_cost * price;
								}
								if (product.contract_currency == 2) {
									euro_total += delivered_quantity_cost * price;
								}
								if (product.contract_currency == 3) {
									usd_total += delivered_quantity_cost * price;
								}

							} else {
								euro_total += delivered_quantity_cost * price;
							}

		              		delivered_total += delivered_quantity_cost * price;

							if (product.weight) {
		              			totalWeight += parseFloat(product.weight);
							}


							let table = null;
							if (product.payments.length > 0) {
								table = <Table striped bordered condensed hover style={{ marginBottom: '0px' }}>
									<thead>
										<tr className="info">
											<th>收到账单</th>
											<th>到货数量</th>
											<th>备注</th>
										</tr>
									</thead>
									<tbody>
										{product.payments.map((relation, index) => {
											return <tr>
												<td className='text-success'>{relation.payment ? relation.payment.invoice_number : ''}</td>
												<td className='text-success'>{relation.amount}</td>
												<td>{relation.note}</td>
											</tr>
										})}
									</tbody>
								</Table>;
							}
							
		              		let productItem = (
		              			<tr key={index}>
		              				<td>{index+1}</td>
		              				<td>{product.id}</td>
		              				<td><Link to={'/order/'+product.oid}>
										{product.order_name}
										{product.order && product.order.transport_mode == 2 ? <><p style={{padding:'0px', fontSize:'16px'}}>🌊🚢🌊 海运订单</p></> : null }
									</Link></td>
		              				<td  style={{ maxWidth: '200px' }}>{product.client_name}</td>
		              				{/* <td>{product.contract_name}</td> */}
		              				<td style={{ maxWidth: '200px' }}>{product.brand_name}<br/>{product.name}</td>
		              				<td>
										<Space direction='vertical'>
										{product.need_gutschrift ?
											<>
												<span>
													<Tooltip arrow={false} title={`标记于 ${product.need_gutschrift_date}`} placement="left" mouseEnterDelay={0} mouseLeaveDelay={0}>
														<strong className="text-warning">
																需要 Gutschrift
														</strong>
													</Tooltip>
												</span>
											</>
											: null}
										{product.received_gutschrift ?
											<>
												<span>
													<Tooltip arrow={false} title={`标记于 ${product.received_gutschrift_date}`} placement="left" mouseEnterDelay={0} mouseLeaveDelay={0}>
														<strong className="text-success">
																收到 Gutschrift
														</strong>
													</Tooltip>
												</span>
											</>
											: null}
										</Space>
									</td>
		              				<td>{table}</td>
		              				<td>{product.amount}</td>
		              				<td>{ product.delivered_quantity > 0 ? 
									  (product.delivered_quantity == product.amount) ? 
									  <p className="text-success">{product.amount}</p> :
									  <p className="text-danger">{product.delivered_quantity}</p> 
									: <p className="text-success">{product.amount}</p> }</td>
		              				<td>{(price*1).toFixed(2)} {currency}</td>
		              				<td>{(delivered_quantity_cost*price).toFixed(2)} {currency}</td>
		              				<td>{(product.weight*1).toFixed(2)} kg</td>
		              			</tr>
		              		);

	                    	return productItem;
		              	})
		            }

		            <tr>
          				<td></td>
          				<td></td>
          				<td></td>
          				<td></td>
          				<td></td>
          				<td></td>
          				<td></td>
          				<td></td>
          				<td></td>
          				<td></td>
          				{/* <td></td>
          				<td></td> */}
          				<td>
							{(euro_total).toFixed(2)} €
							<br/>
							{(usd_total).toFixed(2)} $
							<br/>
							{(cny_total).toFixed(2)} ¥
						</td>
          				<td>
							{(totalWeight).toFixed(2)} kg
						</td>
          			</tr>
		            
			    </tbody>
		  	</Table>

	    );
  	}
  
}

export default GutschriftProductTable;
